import { AdminPermissionLevel } from "src/enums/AdminPermissionLevel.enum";

export const getRole = (permissionLevel) => {
	switch (permissionLevel) {
		case 0:
			return AdminPermissionLevel.SuperAdmin;
		case 1:
			return AdminPermissionLevel.Admin;
		case 2:
			return AdminPermissionLevel.Editor;
		case 3:
			return AdminPermissionLevel.Viewer;
		default:
			return "Unknown Role";
	}
};
